<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>单个卡组集齐人数</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="选择活动" prop="id">
        <el-select
          v-model="queryParams.id"
          clearable
          style="width: 380px;"
          placeholder="请选择"
          filterable
          @change="idChange"
          @visible-change="handleVisibleChange"
        >
          <el-option
            v-for="item in actArr"
            :key="item.value"
            :label="getActOptionLabel(item)"
            :value="item.value"
          />
          <el-option
            v-if="hasMoreAct"
            value=""
            disabled
            style="text-align: center; cursor: pointer;"
          >
            <span v-if="actLoading" style="color: #999;">加载中...</span>
            <span v-else style="color: #409EFF;" @click.stop="loadMoreAct">点击加载更多</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          :disabled="dateDisabled"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          :disabled="dateDisabled"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery(false)">查询</el-button>
        <el-button icon="el-icon-download" size="mini" :loading="loading" @click="handleQuery(true)">导出</el-button>
      </el-form-item>
    </el-form>

    <template>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        show-summary
        :summary-method="getSummary"
      >
        <el-table-column
          prop="date"
          label="日期"
          align="center"
        />
        <el-table-column
          v-for="(item, index) in cardGroup"
          :key="index"
          align="center"
          :label="item.cg_name"
        >
          <template slot-scope="{row}">
            <span v-if="row.data[item.cgid]">{{ row.data[item.cgid] }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>

      </el-table>
    </template>
    <echartTemp ref="group" title="单个卡组集齐人数" />
  </el-card>
</template>
<script >
import { getCardGroupCountStat } from '@/api/config/card-stat'
import echartTemp from '@/components/Charts/Charts.vue'
import actList from '../mixins/actList.js'
import { getLastDates } from '@/utils/index.js'

export default {
  components: {
    echartTemp
  },
  mixins: [actList],
  props: {
    selectedActId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      loading: false,
      dateDisabled: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 0,
        id: '',
        startString: '',
        endString: ''
      },
      cardGroup: []
    }
  },
  watch: {
    selectedActId: {
      immediate: true,
      handler(val) {
        if (val !== undefined && val !== '') {
          this.syncActChange(val)
        }
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
  },
  mounted() {
    this.loadActList()
  },
  methods: {
    getActOptionLabel(item) {
      const actName = this.actNameMap[item.value] || ''
      const dateRange = this.dateRange[item.value] || item.label
      return actName ? `${actName} - ${dateRange}` : dateRange
    },
    getTables() {
      this.loading = true
      getCardGroupCountStat(this.queryParams).then(res => {
        this.loading = false
        if (this.queryParams.type > 0) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
        }
        const { data, group } = res.data
        this.cardGroup = group
        this.tableData = data
        this.refreshChart()
      })
    },
    handleQuery(isExport) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.queryParams.type = 0
      if (isExport) {
        this.queryParams.type = 1
      }
      this.getTables()
    },
    refreshChart() {
      const legend = []
      const tempMap = {}
      const gidData = {}
      for (const i in this.cardGroup) {
        gidData[this.cardGroup[i].cgid] = 0
        tempMap[this.cardGroup[i].cgid] = this.cardGroup[i].cg_name
        legend.push(this.cardGroup[i].cg_name)
      }
      const obj = { legend: legend, series: [], xAxis: legend }

      for (const i in this.tableData) {
        const val = this.tableData[i]
        for (const j in this.cardGroup) {
          const cgid = this.cardGroup[j].cgid
          const valData = val.data[cgid]
          if (valData) {
            gidData[cgid] += valData
          }
        }
      }

      const data = []
      for (const i in this.cardGroup) {
        const cgid = this.cardGroup[i].cgid
        data.push(gidData[cgid])
      }

      const temp = {
        name: '汇总',
        data: data,
        type: 'bar',
        label: {
          show: true,
          position: 'top',
          formatter: '{c}'
        }
      }
      obj.series.push(temp)

      this.$refs.group.refresh(obj)
    },
    idChange(event) {
      this.queryParams.startString = ''
      this.queryParams.endString = ''
      if (event !== '') {
        const dateRange = this.dateRange[event]
        const dateArr = dateRange.split('至')
        this.queryParams.startString = dateArr[0]
        this.queryParams.endString = dateArr[1]
      }

      this.dateDisabled = event !== ''
    },
    syncActChange(actId) {
      this.queryParams.id = actId
      this.idChange(actId)
    },
    getSummary(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总'
          return
        }
        const cgid = this.cardGroup[index - 1]?.cgid
        if (!cgid) {
          sums[index] = 0
          return
        }
        let total = 0
        for (const row of data) {
          const val = row.data[cgid]
          total += val ? Number(val) : 0
        }
        sums[index] = total
      })
      return sums
    }
  }
}
</script>
<style scoped>

</style>
